import React from 'react';
import CtaForm from './CtaForm';

const CtafromSection = (props) => {
    return (
        <section className={"" +props.hclass}>
            <div className="container mt-5">
                <div className="cta_wrap">
                    <div className="content">
                        <h2>Contáctanos</h2>
                        <p>¿Deseas realizarte una intervención o alquilar nuestro quirófano?</p>
                    </div>
                    <CtaForm/>
                </div>
            </div>
        </section>
    );
};

export default CtafromSection;